export const nullChecker = (cell) => {
  if (cell === null) {
    return "-";
  }
  return cell;
};
